import React from 'react';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export const Logo = ({
  size = 'md',
  className = ''
}: LogoProps) => {
  const sizes = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-12'
  };
  return <img src="https://cdn.magicpatterns.com/uploads/jqGZf163nFihHNRd2HRNua/AIN-logo.svg" alt="AIN" className={`${sizes[size]} w-auto select-none ${className}`} draggable={false} data-id="element-12" />;
};